import * as React from 'react';

import { Description } from './parts/Description';
import { Title } from './parts/Title';
import * as styles from './styles.css';
import { INewbuildingHeaderSeoUrl } from '../../types/newbuildingHeader';

interface INewbuildingHeaderSeoProps {
  title: string;
  url?: INewbuildingHeaderSeoUrl;
  description?: string;
}

export const NewbuildingHeaderSeo: React.FC<INewbuildingHeaderSeoProps> = ({ title, url, description }) => {
  return (
    <div className={styles['content']}>
      <Title title={title} url={url} />
      {description && <Description description={description} />}
    </div>
  );
};
